module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Library-2cc87b12ea3504404e2998969a10585e.svg";